module.exports = __webpack_public_path__ + "img/product_stkr_promotion.837bbb94.svg";